import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import {Translate} from "app/services/translate";
import {Amounts} from "./amounts/amounts";
import {CalculatorActions} from "actions/calculatorActions";
import {CalculatorService} from "./calculator.services";
import {CalculatorHandler} from "./calculator.handler";
import {CalculatorProvider} from "./calculator.provider";
import {calculatorPublisher} from "./publisher/calculatorPublisher";
import {Benefits} from "./benefits/benefits";
import {Badge} from "./badge/Badge";
import {ExchangeRates} from "./exchangeRates/exchangeRates";

@connect((state) => {
    return {
        calculator: state.calculator
    };
})

export class Calculator extends Component {
    static get propTypes() {
        return {
            dispatch: PropTypes.func,
            calculator: PropTypes.object,
        }
    }

    constructor(props) {
        super(props);
        this.handler = new CalculatorHandler(props.dispatch);
        this.service = new CalculatorService(props.dispatch);
        this.calculatorSettings = CalculatorProvider.declareSettings();
        this.actions = CalculatorActions();

        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(this.actions.initCalculatorAction());
    }

    async handleCountryChange(country, type) {
        const prevState = this.props.calculator;
        await this.handler.onCountryChange(prevState, type, country);

        const nextState = this.props.calculator;
        this.service.calculateAmount(nextState, type);
        this.useUpdaters(this.props.calculator);
    }

    async handleAmountChange(type, amount) {
        const prevState = this.props.calculator;
        await this.handler.onAmountChange(prevState, type, amount);

        const nextState = this.props.calculator;
        this.service.calculateAmount(nextState, type);
        this.useUpdaters(this.props.calculator);
    }

    async handleCurrencyChange(currency, type) {
        const prevState = this.props.calculator;
        await this.handler.onCurrencyChange(prevState, type, currency);

        const nextState = this.props.calculator;
        this.service.calculateAmount(nextState, type);
        this.useUpdaters(this.props.calculator);
    }

    /** @private */
    useUpdaters(calculator) {
        this.service.updateCookies(calculator);
        calculatorPublisher(calculator);
    }

    render() {
        const {
            inProgress,
            countryIn,
            countryOut,
            availableCountriesIn,
            availableCountriesOut,
            availableCurrenciesIn,
            availableCurrenciesOut,
            amountIn,
            amountOut,
            exchange,
        } = this.props.calculator;

        const {disableAdditionalInformation, disableCountries, showRates} = this.calculatorSettings;

        return !inProgress ? (
            <>
                <div className='calculator-wrapper'>
                    {disableCountries && <h2 className="heading">{Translate('calculator_check_recipient_amount')}</h2>}
                    <div className="row-amounts">
                        <Amounts
                            settings={this.calculatorSettings}
                            countryIn={countryIn}
                            countryOut={countryOut}
                            availableCountriesIn={availableCountriesIn}
                            availableCountriesOut={availableCountriesOut}
                            availableCurrenciesIn={availableCurrenciesIn}
                            availableCurrenciesOut={availableCurrenciesOut}
                            amountIn={amountIn}
                            amountOut={amountOut}
                            onCountryChange={this.handleCountryChange}
                            onAmountChange={this.handleAmountChange}
                            onCurrencyChange={this.handleCurrencyChange}/>
                    </div>
                    <div className="row row-submit">
                        <div className="col-12 submit-wrapper">
                            <a
                                href={Translate('signing_register_url')}
                                className="btn sign js-registration-modal-open">
                                {Translate('commons_send_transfer')}
                            </a>
                        </div>
                    </div>
                    {!disableAdditionalInformation && (
                        <>
                            <Badge/>
                            <Benefits exchange={exchange}/>
                        </>
                    )}
                </div>
                {showRates && <ExchangeRates
                    availableCurrenciesIn={availableCurrenciesIn}
                    availableCurrenciesOut={availableCurrenciesOut}
                    currency={amountIn.amount.currency}
                    onCurrencyChange={this.handleCurrencyChange}/>}
            </>
        ) : (
            <div className="sk-circle main-calc"/>
        )
    }
}
